"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const languageMsg = {
  SEND_INVITATION_LABEL: 'Send invitation',
  ROLE_LABEL: 'Role',
  USERS_ASSIGNED_LABEL: 'Users assigned',
  SEND_INVITATION_INFO_TEXT1: 'If you are inviting a new user the recipient will receive an email with a link to sign up.',
  SEND_INVITATION_INFO_TEXT2: 'If the user is already signed up they will receive a notification to let them know they have been given access to the <MineSiteLabel> selected'
};
var _default = exports.default = languageMsg;